// frontend/src/components/LayoutTab.js
import { PALETTE_OPTIONS_ALL as PALETTE_OPTIONS, SectionCard } from "@/components/shared";

const Toggle = ({ label, checked, onChange }) => (
  <label className="flex items-center gap-2 text-sm text-[#3A3530] cursor-pointer">
    <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} className="accent-[#2B7D6E]" />
    {label}
  </label>
);

const ColorSelect = ({ label, value, onChange, colors }) => (
  <label className="block">
    <span className="block text-xs mb-1 text-[#3A3530]">{label}</span>
    <div className="flex items-center gap-2">
      <div className="w-6 h-6 leadline-border-thin" style={{ backgroundColor: colors[value] || "#ccc" }} />
      <select
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        className="leadline-border-thin px-2 py-1 bg-white text-sm flex-1"
      >
        {PALETTE_OPTIONS.map((opt) => (
          <option key={opt.key} value={opt.key}>{opt.label}</option>
        ))}
      </select>
    </div>
  </label>
);

function LayoutTab({ config, onChange }) {
  const sections = config.sections || {};

  const updateSection = (section, field, value) => {
    const next = JSON.parse(JSON.stringify(config));
    if (!next.sections) next.sections = {};
    if (!next.sections[section]) next.sections[section] = {};
    next.sections[section][field] = value;
    onChange(next);
  };

  const hero = sections.hero || {};
  const intro = sections.intro || {};
  const products = sections.products || {};
  const footer = sections.footer || {};

  return (
    <div className="space-y-4">
      <SectionCard title="Hero Section">
        <ColorSelect
          label="Background Color"
          value={hero.backgroundColor || "backgroundClear"}
          onChange={(v) => updateSection("hero", "backgroundColor", v)}
          colors={config.colors}
        />
        <Toggle
          label="Show border"
          checked={hero.showBorder !== false}
          onChange={(v) => updateSection("hero", "showBorder", v)}
        />
        <Toggle
          label="Show corner accents"
          checked={hero.showCornerAccents !== false}
          onChange={(v) => updateSection("hero", "showCornerAccents", v)}
        />
      </SectionCard>

      <SectionCard title="Intro Section">
        <Toggle
          label="Show intro section"
          checked={intro.visible !== false}
          onChange={(v) => updateSection("intro", "visible", v)}
        />
        <p className="text-xs text-[#3A3530] opacity-60">When hidden, the hero section expands to fill the space.</p>
        <ColorSelect
          label="Background Color"
          value={intro.backgroundColor || "backgroundClear"}
          onChange={(v) => updateSection("intro", "backgroundColor", v)}
          colors={config.colors}
        />
      </SectionCard>

      <SectionCard title="Products Section">
        <Toggle
          label="Show art deco dividers between groups"
          checked={products.showDividers !== false}
          onChange={(v) => updateSection("products", "showDividers", v)}
        />
        <Toggle
          label="Show mosaic bar"
          checked={products.showMosaicBar === true}
          onChange={(v) => updateSection("products", "showMosaicBar", v)}
        />
      </SectionCard>

      <SectionCard title="Footer Section">
        <ColorSelect
          label="Background Color"
          value={footer.backgroundColor || "leadline"}
          onChange={(v) => updateSection("footer", "backgroundColor", v)}
          colors={config.colors}
        />
        <ColorSelect
          label="Text Color"
          value={footer.textColor || "backgroundClear"}
          onChange={(v) => updateSection("footer", "textColor", v)}
          colors={config.colors}
        />
        <Toggle
          label="Show mosaic bar"
          checked={footer.showMosaicBar !== false}
          onChange={(v) => updateSection("footer", "showMosaicBar", v)}
        />
      </SectionCard>
    </div>
  );
}

export default LayoutTab;
